import { useState, useEffect } from "react";
import { useAuth } from "../../context/Auth";
import { Outlet } from "react-router-dom";
import axios from "axios";
import Spinner from "./Spinner";
import { API_BASE_URL } from "../../config/config.js";

export default function PrivateRoute() {
  const [ok, setOk] = useState(false);
  const [auth, setAuth] = useAuth();

  useEffect(() => {
    const authCheck = async () => {
      try {
        console.log("Validating token:", (auth && auth.token) ? "Token exists" : "No token");
        console.log("Backend URL:", API_BASE_URL);

        const res = await axios.post(`${API_BASE_URL}/api/token/validate`, {}, {
          headers: {
            'Authorization': `Bearer ${auth.token}`
          }
        });
        console.log("Token validation response:", res.data);

        if (res.data.success) {
          console.log("Token validation successful");
          setOk(true);
        } else {
          console.log("Token validation failed - response not successful");
          setOk(false);
        }
      } catch (error) {
        console.error("Token validation failed:", error);
        console.log("Error response:", error.response && error.response.data);
        setOk(false);
      }
    };
    if (auth && auth.token) {
      authCheck();
    } else {
      console.log("No token available, showing spinner");
      setOk(false);
    }
  }, [auth && auth.token]);

  return ok ? <Outlet /> : <Spinner />;
}
